couponCardTemplate = require '../../coupons/coupon_card.html.mustache'
dealCardTemplate = require '../../deals/deal_card.html.mustache'
CouponCard = require '../../coupons/frontend/coupon_card'

class MultipleOffers

  constructor: ({ @el, @placeId, @isUsingOfferAggregator, @totalDeals, @totalCoupons, @limit, @initialCouponLimit }) ->
    @$el = $ @el
    @rootUrl = '/merchant-page'
    @offerSelector = '.offer'
    @$deals = @$el.find '.offer-cards-deal'
    @$coupons = @$el.find '.offer-cards-coupon'
    @$showMore = @$el.find '.show-more-button'
    @$showMoreText = @$showMore.find '.show-more-text'
    @$showMoreLoader = @$showMore.find '.show-more-loader'
    @activeShowMoreClass = 'active'
    @offerProfiles = [
      {
        dataKey:       'deals'
        template:       dealCardTemplate
        container:      @$deals
        offerCardClass: null
      },
      {
        dataKey:       'coupons',
        template:       couponCardTemplate
        container:      @$coupons
        offerCardClass: CouponCard
      }
    ]

    @init()
    @bindEventHandlers()

  init: ->
    # Initially, hide all offers except the first @limit.
    hiddenStartingIndex = @limit - 1
    @$el.find("#{@offerSelector}:gt(#{hiddenStartingIndex})").hide()

    # If there are more than @initialCouponLimit coupons displayed at
    # the initial page load, we need to hide the rest except the first
    # @initialCouponLimit coupons. This is based on a policy we need to
    # comply with so Google will not penalize Coupons team for potential
    # duplicate content.
    $visibleCoupons = @$coupons.find "#{@offerSelector}:visible"
    if $visibleCoupons.size() > @initialCouponLimit
      $visibleCoupons.slice(@initialCouponLimit).hide()

  bindEventHandlers: ->
    @$showMore.click @doShowMore

  doShowMore: =>
    return if @$showMore.hasClass @activeShowMoreClass
    @showLoader()

    if @isUsingOfferAggregator
      cb = =>
        @uncoverNextBatch()
        @controlShowMoreVisibility()
        @hideLoader()

      if @isOfferLoadableViaOfferAggregator()
        @fetchOffers cb
      else
        cb()

    else
      @hideShowMore()
      @uncoverAll()

  fetchOffers: (cb) ->
    data = {}
    offerTypes = []

    for offerType in ['deal', 'coupon']
      if @isOfferLoadableViaOfferAggregator offerType

        # The offset for each type is equal to the total number of offers
        # for that type that have been loaded. For example if you have 20
        # deals loaded already, the next OA call you will have offset=20.
        data["#{offerType}_offset"] = @getTotalOffersLoaded offerType
        data["#{offerType}_limit"] = @limit
        offerTypes.push offerType

    return cb() unless offerTypes.length > 0
    data.types = offerTypes.join ','

    $.ajax
      url: "#{@rootUrl}/multiple-offers/fetch?place_id=#{@placeId}"
      method: 'GET'
      data: data
      contentType: 'application/json'
      success: (res) =>
        return unless res.data? and res.result is 'ok'
        @appendOffers res.data

      complete: ->
        cb()

  appendOffers: (offerData) ->
    return unless offerData?

    for offerProfile in @offerProfiles
      if offerData[offerProfile.dataKey]?.list?.length > 0
        for row in offerData[offerProfile.dataKey].list
          row.translate = row.t = -> (text) -> I18n.translate text
          $row = $ offerProfile.template.render(row)
          new offerProfile.offerCardClass($row) if offerProfile.offerCardClass?
          offerProfile.container.append $row.hide()

  getOfferCards: (hiddenOnly, first, type) ->
    containerDecorator = if type? then ".offer-cards-#{type} " else ''
    visibilityDecorator = if hiddenOnly then ':hidden' else ''
    counterDecorator = if first > 0 then ":lt(#{first})" else ''
    @$el.find "#{containerDecorator}#{@offerSelector}#{visibilityDecorator}#{counterDecorator}"

  getTotalOffers: (type) ->
    switch type
      when 'deal' then @totalDeals
      when 'coupon' then @totalCoupons
      else @totalDeals + @totalCoupons

  getTotalOffersLoaded: (type) ->
    @getOfferCards(false, 0, type).size()

  getTotalOffersHidden: (type) ->
    @getOfferCards(true, 0, type).size()

  isOfferLoadableViaOfferAggregator: (type) ->
    @getTotalOffers(type) > @getTotalOffersLoaded(type)

  isOfferUncoverable: ->
    @getTotalOffersHidden() > 0

  showLoader: ->
    @$showMore.addClass @activeShowMoreClass
    @$showMoreText.hide()
    @$showMoreLoader.show()

  hideLoader: ->
    @$showMoreLoader.hide()
    @$showMoreText.show()
    @$showMore.removeClass @activeShowMoreClass

  hideShowMore: ->
    @hideLoader()
    @$showMore.hide()

  controlShowMoreVisibility: ->
    @hideShowMore() unless @isOfferLoadableViaOfferAggregator() or @isOfferUncoverable()

  showOfferCards: (offerCards) ->
    offerCards.slideDown 'fast'

  uncoverNextBatch: ->
    @showOfferCards @getOfferCards(true, @limit)

  uncoverAll: ->
    @showOfferCards @getOfferCards(true, 0)

$ ->

  el = '#multiple-offers'
  $el = $ el

  placeId = $el.data 'place-id'
  isUsingOfferAggregator = Boolean $el.data('offer-aggregator-enabled')
  totalDeals = parseInt $el.data('total-deals')
  totalCoupons = parseInt $el.data('total-coupons')
  limit = parseInt $el.data('offer-aggregator-limit')
  initialCouponLimit = parseInt $el.data('initial-coupon-limit')

  new MultipleOffers { el, placeId, isUsingOfferAggregator, totalDeals, totalCoupons, limit, initialCouponLimit }
